import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { EmopItemClass } from '../../../app/class/EmopItemClass/EmopItemClass';
import { EmopFormProClass } from '../../../app/class/EmopFormProClass/EmopFormProClass';

@Component({
  selector: 'emop-form-pro',
  templateUrl: './emop-form-pro.component.html',
  styleUrls: ['./emop-form-pro.component.scss']
})
export class EmopFormProComponent implements OnInit {
  hasFeedback;
  @Input() data: EmopFormProClass;
  /**
   * 排列方式
   */
  @Input() layout: 'horizontal' | 'vertical' | 'inline' = 'horizontal';
  @Input() col: number = 2;
  @Output() valueChange = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    if (!this.data) return console.error('请传入data');
    // if (new Set(this.data.map(item => item.key)).size !== this.data.length) {
    //   console.error('传入的key属性值必须唯一, 否则会造成不必要的数据问题');
    // }
  }
}
